import { POSTLoginReqBody } from '@myme/api';
import { kratosIntegration } from '@myme/utils';
import { SelfServiceLoginFlow } from '@ory/kratos-client';
import { KratosInitFlow } from '../types';

export const handleLoginWeb = async (loginFlow: KratosInitFlow, data: POSTLoginReqBody) => {
  const overrideReqBody = {
    csrf_token: loginFlow.csfrToken,
    method: 'password',
    password: data.password,
    password_identifier: data.email
  };

  return kratosIntegration.request.submitSelfServiceLoginFlow(loginFlow.flowId, undefined, overrideReqBody);
};

export const handleLoginMobile = async (loginFlow: SelfServiceLoginFlow, data: POSTLoginReqBody) => {
  const overrideReqBody = {
    method: 'password',
    password: data.password,
    password_identifier: data.email
  };

  return kratosIntegration.request.submitSelfServiceLoginFlow(loginFlow.id, undefined, overrideReqBody);
};
